import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../services/api';

const Brands = () => {
  const { t } = useTranslation();
  const [brands,       setBrands]      = useState([]);
  const [showByRegion, setShowByRegion] = useState(false);
  const [transitioning,setTransitioning]= useState(false);
  const [loading,      setLoading]     = useState(true);

  useEffect(() => {
    api.getPublicBrands()
      .then(res => setBrands(res.data))
      .catch(() => setBrands([]))
      .finally(() => setLoading(false));
  }, []);

  // Raggruppa brand per regione
  const brandsByRegion = brands.reduce((acc, brand) => {
    brand.regions.forEach(region => {
      if (!acc[region.name]) acc[region.name] = [];
      acc[region.name].push(brand);
    });
    return acc;
  }, {});

  const handleSwitch = () => {
    setTransitioning(true);
    setTimeout(() => {
      setShowByRegion(v => !v);
      setTransitioning(false);
    }, 500);
  };

  if (loading) {
    return (
      <div className="brands-container pt-16 pb-8 pl-8 pr-8 lg:pt-24 lg:pb-12 lg:pl-12 lg:pr-12 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 mt-4">
        <div className="text-gray-500 text-center py-16">Caricamento...</div>
      </div>
    );
  }

  return (
    <div className="brands-container pt-16 pb-8 pl-8 pr-8 lg:pt-24 lg:pb-12 lg:pl-12 lg:pr-12 bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 mt-4">
      <section className="brands-section">
        <h1 className="text-4xl mb-6">{t('brands.title')}</h1>

        <div className="switch-container my-6 flex justify-center">
          <button
            className="sm:text-lg md:text-lg lg:text-xl px-6 py-2 bg-black text-white rounded-lg border-2 border-white shadow-md hover:border-red-500 hover:text-red-500 hover:bg-black hover:shadow-lg transition duration-300"
            onClick={handleSwitch}
          >
            {showByRegion ? t('brands.showAll') : t('brands.showByRegion')}
          </button>
        </div>

        {showByRegion ? (
          <div className={`mt-4 ${transitioning ? 'fade-out' : 'fade-in'}`}>
            {Object.entries(brandsByRegion).map(([regionName, regionBrands]) => (
              <div key={regionName} className="region-section mt-6 mb-6 rounded-lg shadow-sm">
                <h4 className="text-2xl sm:text-2xl md:text-3xl lg:text-3xl mb-4">{regionName}</h4>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
                  {regionBrands.map(brand => (
                    <div
                      key={brand.id}
                      className="bg-black brand-card cursor-pointer text-center p-2 rounded-lg border-2 border-white hover:border-red-500 transition duration-300"
                      onClick={() => brand.website_url && window.open(brand.website_url, '_blank')}
                    >
                      <img
                        src={brand.logo}
                        alt={brand.name}
                        className="grayscale w-full h-32 sm:h-40 object-contain mx-auto opacity-100 hover:opacity-75 hover:scale-105 transition duration-300"
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={`grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 mt-6 ${transitioning ? 'fade-out' : 'fade-in'}`}>
            {brands.map(brand => (
              <div
                key={brand.id}
                className="bg-black brand-card cursor-pointer text-center border-2 border-white p-2 rounded-lg hover:border-red-500 transition duration-300"
                onClick={() => brand.website_url && window.open(brand.website_url, '_blank')}
              >
                <img
                  src={brand.logo}
                  alt={brand.name}
                  className="grayscale w-full h-32 sm:h-40 object-contain mx-auto opacity-100 hover:opacity-75 hover:scale-105 transition duration-300"
                />
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default Brands;
